import React from 'react'
import { Api } from '../../libs/api'
import WinnerList from './winnerList'

class Winners extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            vdata: 'load',
        }
    }

    componentDidMount() {
        Api.getEventWin(this.props.idx).then(rst => {
            if (rst.data.code === '200') {
                this.setState({ vdata: rst.data.data })
            }
        })
    }

    render() {
        const v = this.state.vdata
        if (v === 'load') return <p className="comm_loading_inside on" />
        return (
            <div className="winnerList">
                <font className="thkU">이벤트에 참여해준 모든 분들께 깊은 감사의 말씀을 드립니다.</font>
                <h2>당첨자</h2>
                {v.eventInfo[0].f_win === 1 ? (
                    <React.Fragment>
                        {v.noRankWinList.map((vl, i) => {
                            const gift = vl.gift_item
                            const key = i
                            return (
                                <div className="winnerBlk" key={key}>
                                    <strong>
                                        <font className="clrpont1">
                                            {gift.nm_gift ? gift.nm_gift : `${gift.maker_name} ${gift.item_name}`}(
                                            {gift.cnt_gift}명)
                                        </font>
                                    </strong>
                                    <WinnerList data={vl.win_list} />
                                </div>
                            )
                        })}
                    </React.Fragment>
                ) : (
                    <React.Fragment>
                        {v.rankWinList.map((vl, i) => {
                            const gift = vl.gift_list[0]
                            const key = i
                            return (
                                <div className="winnerBlk" key={key}>
                                    <strong>
                                        {vl.rank_win}등 -
                                        <font className="clrpont1">
                                            {gift.nm_gift ? gift.nm_gift : `${gift.maker_name} ${gift.item_name}`}(
                                            {gift.cnt_gift}명)
                                        </font>
                                    </strong>
                                    <WinnerList data={vl.win_list} />
                                </div>
                            )
                        })}
                    </React.Fragment>
                )}
            </div>
        )
    }
}
export default Winners
